import "./footer.css"

type footerElementType = {
    label: string; 
    link?: string;
}

const Footer = () => {
    
    const footerElements = [
        {
            label: "Gestion de patrimoine"
        },
        {
            label: "version 1.2.2"
        },
        {
            label: "Développé par Caroline Rousset"
        },
        {
            label: "carolinejd.rousset@gmail.com",
            link: "mailto:carolinejd.rousset@gmail.com"
        },
        {
            label: "© 2026 Tous droits réservés."
        }
    ] as footerElementType[];

    return <div className="footer">
        <div className="footer-divider"></div>
        <div className="footer-elements">
            {footerElements.map((footerElement, i) => 
            <div key={`footerElement-${i}`} className="footer-container">
                {footerElement.link ? 
                <a className="footer-link" href={footerElement.link}>{footerElement.label}</a> 
                : <span className="footer-label">{footerElement.label}</span>}
                {i != footerElements.length - 1 && <div>·</div>}
            </div>
            )}
            </div>   
    </div>
};

export default Footer;


